export default __webpack_public_path__ + "static/media/polymer.6f2ac6cf.svg";